/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Rename_FieldInputs */

const en_us2_plan_rename_field = /** @type {(inputs: Plan_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout name`)
};

const pt_br2_plan_rename_field = /** @type {(inputs: Plan_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do treino`)
};

const es_419_plan_rename_field = /** @type {(inputs: Plan_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del entrenamiento`)
};

const pt_pt2_plan_rename_field = /** @type {(inputs: Plan_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do treino`)
};

const fr_fr2_plan_rename_field = /** @type {(inputs: Plan_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la séance`)
};

const de_de2_plan_rename_field = /** @type {(inputs: Plan_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Trainings`)
};

const it_it2_plan_rename_field = /** @type {(inputs: Plan_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome dell'allenamento`)
};

/**
* | output |
* | --- |
* | "Workout name" |
*
* @param {Plan_Rename_FieldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_rename_field = /** @type {((inputs?: Plan_Rename_FieldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Rename_FieldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_rename_field(inputs)
	if (locale === "es-419") return es_419_plan_rename_field(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_rename_field(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_rename_field(inputs)
	if (locale === "de-DE") return de_de2_plan_rename_field(inputs)
	if (locale === "it-IT") return it_it2_plan_rename_field(inputs)
	return en_us2_plan_rename_field(inputs)
});
export { plan_rename_field as "plan.rename_field" }